/**
 * NDG Volunteer Form — view.js
 *
 * Store Interactivity API pour le formulaire d'inscription bénévoles.
 */

import { store, getContext } from '@wordpress/interactivity';
import { getRecaptchaToken, preloadRecaptcha } from '../../js/utils/recaptcha.js';

const STORE_NS = 'ndg/volunteer-form';

store( STORE_NS, {

	actions: {

		preloadRecaptcha() {
			preloadRecaptcha( getContext().recaptchaSiteKey );
		},

		setField( event ) {
			const field = event.target.dataset.field;
			if ( field ) {
				getContext()[ field ] = event.target.value;
			}
		},

		*submit( event ) {
			event.preventDefault();

			const context = getContext();

			if ( context.isSubmitting ) return;

			context.isSubmitting = true;
			context.isSuccess    = false;
			context.isError      = false;

			try {
				const token = yield getRecaptchaToken( context.recaptchaSiteKey, context.recaptchaAction );

				const response = yield fetch( context.restUrl, {
					method:  'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce':   context.nonce,
					},
					body: JSON.stringify( {
						lastname:        context.lastname,
						firstname:       context.firstname,
						email:           context.email,
						phone:           context.phone,
						event_id:        context.eventId,
						message:         context.message,
						website:         context.website,
						recaptcha_token: token,
					} ),
				} );

				const data = yield response.json();

				if ( response.ok && data.ok ) {
					context.isSuccess  = true;
					context.lastname   = '';
					context.firstname  = '';
					context.email      = '';
					context.phone      = '';
					context.message    = '';
					// eventId n'est pas remis à '' : l'utilisateur peut vouloir
					// inscrire une 2e personne pour le même event juste après.
				} else {
					context.isError = true;
				}
			} catch {
				context.isError = true;
			} finally {
				context.isSubmitting = false;
			}
		},
	},
} );
